import {
  Box,
  CircularProgress,
  IconButton,
  Typography,
} from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';
import type { IActivityLogPhase } from '../../interfaces/ui';

interface ActivityLogTabProps {
  activityLog: IActivityLogPhase[];
  loading: boolean;
  error: string | null;
  onRefresh?: () => void;
}

export default function ActivityLogTab({
  activityLog,
  loading,
  error,
  onRefresh,
}: ActivityLogTabProps) {
  return (
    <Box className="ec-tab-panel">
      <Box className="ec-activity-header">
        <Typography className="ec-artifact-title ec-activity-title">
          AI Activity Timeline
        </Typography>
        <IconButton
          aria-label="Refresh activity log"
          title="Refresh activity log"
          color="primary"
          onClick={onRefresh}
          disabled={!onRefresh || loading}
          className="ec-activity-refresh-btn"
        >
          <RefreshIcon
            className={loading ? 'ec-activity-refresh-icon ec-spin' : 'ec-activity-refresh-icon'}
          />
        </IconButton>
      </Box>
      {loading && activityLog.length === 0 && (
        <Box className="ec-tab-loading">
          <CircularProgress size={24} color="primary" />
          <Typography>Connecting to activity log...</Typography>
        </Box>
      )}
      {error && <Typography className="ec-tab-error">{error}</Typography>}
      <Box className="ec-activity-timeline">
        {activityLog.map((entry, index) => (
          <Box
            key={`${entry.phase}-${entry.startTime}-${index}`}
            className="ec-activity-entry"
          >
            <Typography component="span" className="ec-activity-phase">
              {entry.phase}
            </Typography>
            <Typography component="span" className="ec-activity-detail">
              Status: {entry.status}
            </Typography>
            <Typography component="span" className="ec-activity-detail">
              Events: {entry.events}
            </Typography>
            <Typography component="span" className="ec-activity-detail">
              Start: {entry.startTime}
            </Typography>
            <Typography component="span" className="ec-activity-detail">
              End: {entry.endTime}
            </Typography>
            <Typography component="span" className="ec-activity-detail">
              Duration: {entry.durationSeconds}s
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
